const updateFacilitySlideInfo = ({ id, title, idx_content: content }) => {
	const slideInfo = document.querySelector('.slide-info');
	slideInfo.classList.add('-hide');

	setTimeout(() => {
		slideInfo.firstChild.innerText = title;
		slideInfo.firstChild.nextSibling.innerText = content;
		slideInfo.querySelector('.button-effect').setAttribute(
			'href',
			`facilities#${id}`,
		);

		slideInfo.classList.remove('-hide');
	}, 500);
};

export default updateFacilitySlideInfo;



// WEBPACK FOOTER //
// ./src/js/index/updateFacilitySlideInfo.js